import React from 'react';

//import { Box, TextField } from '@mui/material';

//import BlockFactory from '../blocks/BlockFactory';
import BlockListView from '../blocks/BlockListView';
import BlockListEditView from '../blocks/BlockListEditView';

import InProcModal from './InProcModal';

function ContentView({content, editMode}) {

	console.log("ContentView()");

	//const [contentName,setContentName] = React.useState(content.name);
	const [blocks,setBlocks] = React.useState(content.blocks.map(e => e));
	const [inProcState,setInProcState] = React.useState(false);

	let handleBackgroundChange = async (color) => {
		await content.setBackgroundColor(color, false);
	};

	let handleAclChange = async (acl) => {
		await content.setAcl(acl, false);
	};

	let handleBlockAdd = async (block) => {
		let updatedBlocks = [];

		for (let i = 0; i < blocks.length; i++) {
			updatedBlocks.push(blocks[i]);
		}
		updatedBlocks.push(block);
		setBlocks(updatedBlocks);

		await content.addBlock(block, false);
	};

	let handleBlockDelete = async (block) => {
		let updatedBlocks = [];

		for (let i = 0; i < blocks.length; i++) {
			if (blocks[i].name !== block.name) {
				updatedBlocks.push(blocks[i]);
			}
		}
		setBlocks(updatedBlocks);

		await content.deleteBlock(block, false);
	};

	let handleBlockUpdate = async (block, mustSave) => {
		if (block.type === 'text' && !mustSave) {
			// Due to TextBlockEditView/Quill, UI shall not be updated when mustSave is false.
			//
			await content.updateBlock(block, false);
		}
		else {
			let updatedBlocks = [];

			for (let i = 0; i < blocks.length; i++) {
				if (blocks[i].name === block.name) {
					updatedBlocks.push(block);
				}
				else {
					updatedBlocks.push(blocks[i]);
				}
			}
			setBlocks(updatedBlocks);

			setInProcState(true);
			await content.updateBlock(block, mustSave);
			setInProcState(false);
		}
	};

/*
	function handleContentNameChange(e) {
		let contentName = e.target.value;
		content.name = contentName;
		setContentName(contentName);
	}

	function getContentHeader() {
		return (
			<Box
				display='flex'
				justifyContent='center'
				alignItems='center'
				sx={{
					width: '100%',
					padding: '30px'
				}}
			>
				<TextField
					id="name"
					variant="outlined"
					label="컨텐트명"
					value={contentName}
					onChange={handleContentNameChange}
					sx={{width:'100%'}}
				/>
			</Box>
		);
	}
*/

	function getView() {
		console.log("ContentView.getView()");

		if (blocks) {
			if (editMode === 'content') {
				return (
					<BlockListEditView
						isTemplate={content.isTemplate}
						backgroundColor={content.backgroundColor}
						acl={content.acl}
						blocks={blocks}
						onBackgroundChange={(color) => handleBackgroundChange(color)}
						onAclChange={(acl) => handleAclChange(acl)}
						onBlockAdd={(block) => handleBlockAdd(block)}
						onBlockDelete={(block) => handleBlockDelete(block)}
						onBlockUpdate={(block) => handleBlockUpdate(block, false)}
					/>
				);
			}
			else if (editMode === 'block') {
				return (
					<BlockListView
						backgroundColor={content.backgroundColor}
						blocks={blocks}
						onBlockUpdate={(block) => handleBlockUpdate(block, true)}
					/>
				);
			}
			else {
				return (
					<BlockListView
						backgroundColor={content.backgroundColor}
						blocks={blocks}
					/>
				);
			}
		}
	}

	return (
		<>
			{getView()}
			<InProcModal isOpen={inProcState}/>
		</>
	);
}

export default ContentView;
